import React, { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

const SubscriptionChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartInstance = new Chart(chartRef.current, {
      type: "bar", // Change to 'doughnut' or 'line' if needed
      data: {
        labels: data.map((item) => item._id || "No Plan"),
        datasets: [
          {
            label: "Subscriptions",
            data: data.map((item) => item.count),
            backgroundColor: [
              "#FF6384", // Color for each bar
              "#36A2EB",
              "#FFCE56",
              "#4BC0C0",
              "#9966FF",
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true, // Makes the chart adapt to the container
        maintainAspectRatio: false, // Allows it to resize dynamically
        plugins: {
          legend: {
            display: true,
            position: "top",
          },
        },
        scales: {
          x: {
            ticks: {
              autoSkip: false, // Avoid skipping labels if they fit
            },
          },
        },
      },
    });

    return () => {
      chartInstance.destroy(); // Cleanup when unmounted
    };
  }, [data]);

  return (
    <div style={{ width: "100%", height: "400px" }}> {/* Adjust container height */}
      <canvas ref={chartRef} />
    </div>
  );
};

export default SubscriptionChart;
